import { cn } from "@pax/ui";
import { quietLink, RecaptchaNotice } from "@/features/risk/RecaptchaAttribution";

/**
 * One centred line of small print: Pax's policies, and Google's notice where reCAPTCHA runs. It has
 * no ground of its own, so it sits on whatever page uses it. Put last in a column at least a screen
 * tall: it takes the room left over, so on a short page it rests on the bottom edge, and on a long
 * one it is a short scroll past the end.
 */
export function LegalLine({
  recaptcha = false,
  className,
}: {
  recaptcha?: boolean;
  className?: string;
}) {
  return (
    <p
      className={cn(
        "mt-auto shrink-0 truncate px-3 pt-20 pb-4 text-center text-[10px] leading-none text-muted-foreground",
        className,
      )}
    >
      <a href="/privacy" target="_blank" rel="noreferrer" className={quietLink}>
        Privacy
      </a>
      {" · "}
      <a href="/terms" target="_blank" rel="noreferrer" className={quietLink}>
        Terms
      </a>
      {recaptcha ? (
        <>
          {" · "}
          <RecaptchaNotice />
        </>
      ) : null}
    </p>
  );
}
